/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Trello } from "../types/trello"
import { HELP_ACTION, PUP_DISPLAY_NAME } from "../config"

/**
 * The board-level entry point to the monthly time report.
 *
 * A button of its own rather than a page inside Settings: it is the screen the
 * billing cycle runs through, opened deliberately once a month, and burying it
 * under a gear icon would hide the one thing this power-up is used to finish.
 */
export async function getBoardButton(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.BoardButtonCallback[]> {
  return [
    {
      icon: { dark: props.baseUrl + props.icon.dark, light: props.baseUrl + props.icon.light },
      text: "Time",
      callback: (t: Trello.PowerUp.IFrame) =>
        t.modal({
          // Replaced with the board's name once the report has loaded it —
          // see the updateModal call in TimeReport.
          title: `${PUP_DISPLAY_NAME} | Time`,
          url: "./time-report.html",
          fullscreen: true,
          actions: [HELP_ACTION]
        }),
      condition: "edit"
    }
  ]
}
